import { SOURCE_MULTI_SKU_NUM, UserGetMode } from '@/components/MultiSkuModal/constant';
import { MultiSkuModel } from '@/shop/shop_multi_sku_modal/component';
import Constant from '@/utils/constant';
import {
  GoodDetailData, GoodDetailSkuList, SelectedSkuList
} from '../../../pages/shop/c_shop/component';
import { TotalPrice } from '../Store/model';

const Statistics = Mach.requireModule('Statistics');

export const CID = {
  shop: 'c_waimai_c_overseas_t0hfbtfg',
  fixed_price: 'c_waimai_c_overseas_sn7wr5pd',
  nine_one_nine: 'c_sailor_c_887tosbv',
  multi_sku_modal: 'c_sailor_c_zamjat4k'
};

export const BID = {
  // 点菜页多规格浮层-曝光
  POI_CHOOSE_SPEC_VIEW_BID: {
    MV: 'b_waimai_c_overseas_zcj8vpow_mv',
  },
  //一口价多规格浮层-曝光
  FIXED_PRICE_POI_CHOOSE_SPEC: {
    MV: 'b_waimai_c_overseas_wq2wxft1_mv',
  },
  // 一人食-进店入口
  FIXED_PRICE_SHOP_ENTRY: {
    MV: 'b_sailor_c_kobphk12_mv',
    MC: 'b_sailor_c_kobphk12_mc'
  },
  //商品规格浮层-主规格模块曝光
  MULT_SKU_VARIATION: {
    MV: 'b_sailor_c_508pahrw_mv',
  },

  //一口价-商品规格浮层-主规格模块曝光
  FIXED_PRICE_MULT_SKU_VARIATION: {
    MV: 'b_sailor_c_ttcmoimk_mv',
  },

  // 商品规格浮层-主模块规格查看更多-点击
  MULT_SKU_SHOW_MORE_BTN: {
    MC: 'b_waimai_c_overseas_yf08vylu_mc',
  },
  // 一口价-商品规格浮层-主模块规格查看更多-点击

  FIXED_PRICE_MULT_SKU_SHOW_MORE_BTN: {
    MC: 'b_waimai_c_overseas_dvhsjwp2_mc',
  },
  // 商品规格浮层-加入购物车 点击
  MULT_SKU_ADD_TO_SHOPCART_BTN: {
    MC: 'b_waimai_c_overseas_0jfd5vmd_mc',
  },
  // 一口价-商品规格浮层-加入购物车 点击
  FIXED_PRICE_MULT_SKU_ADD_TO_SHOPCART_BTN: {
    MC: 'b_waimai_c_overseas_ocjy513m_mc',
  },
  //商品规格浮层-数量修改-点击
  MULT_SKU_CHANGE_COUNT: {
    MC: 'b_waimai_c_overseas_eag2ivu5_mc',
  },
  //商品规格浮层-备注
  MULT_SKU_REMARK: {
    MV: 'b_waimai_c_overseas_wbguyjeh_mv',
    MC: 'b_waimai_c_overseas_wbguyjeh_mc',
  },
  //一口价-商品规格浮层-备注
  FIXED_PRICE_MULT_SKU_REMARK: {
    MV: 'b_waimai_c_overseas_vx15y657_mv',
    MC: 'b_waimai_c_overseas_vx15y657_mc',
  },
  // 商品规格浮层-规格选择模块-曝光
  MULT_SKU_SKULIST: {
    MV: 'b_waimai_c_overseas_3w7w6xsq_mv',
  },
  // 一口价-商品规格浮层-规格选择模块-曝光
  FIXED_PRICE_MULT_SKU_SKULIST: {
    MV: 'b_waimai_c_overseas_f2cwprtp_mv',
  },
  //商品规格浮层-分享-点击
  MULT_SKU_SHARE_BTN: {
    MC: 'b_waimai_c_overseas_gi1hj3vz_mc',
  },
  //一口价-商品规格浮层-分享-点击
  FIXED_PRICEMULT_SKU_SHARE_BTN: {
    MC: 'b_waimai_c_overseas_i19gqd57_mc',
  },
  // 919活动多规格浮层-曝光
  NINE_ONE_NINE_MULT_SKU_BID: {
    MV: 'b_sailor_c_b46bt25n_mv',
  },
  MARKETFLOADINGLAYER_BID: {
    MV: 'b_sailor_c_7uqyeozr_mv',
    MC: 'b_sailor_c_eu60n8ky_mc'
  },
  MARKETFLOADINGLAYER_POPUP_VIEW_BID: {
    MV: 'b_sailor_c_5rbyzw11_mv',
    MC: 'b_sailor_c_5rbyzw11_mc',
  },
  NINE_ONE_NINE_POPUP_VIEW_BID: {
    MV: 'b_sailor_c_25g2hopm_mv',
    MC: 'b_sailor_c_25g2hopm_mc',
  },
  // 919活动落地页-规格浮层-加购 点击
  NINE_ONE_NINE_MULT_SKU_ADD_TO_SHOPCART_BTN: {
    MC: 'b_sailor_c_tlc84rn1_mc',
  },
  // 通用弹窗曝光
  PREVIEW_COMMON_DIALOG_BID: {
    MV: 'b_sailor_c_lrycrk7b_mv',
    MC: 'b_sailor_c_lrycrk7b_mc'
  },
  // 一人食弹窗埋点
  FIXED_PRICE_COMMON_DIALOG_BID: {
    MV: 'b_sailor_c_xjvibwep_mv',
    MC: 'b_sailor_c_xjvibwep_mc'
  },

  NORMAL_MULTI_SKU_MODAL_BID: {
    MV: 'b_sailor_c_xakjane4_mv'
  },

  NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID: {
    MV: 'b_sailor_c_fbjupd3f_mv',
    MC: 'b_sailor_c_fbjupd3f_mc'
  },

  NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID: {
    MC: 'b_sailor_c_eapan4ot_mc'
  },

  NORMAL_MULTI_SKU_MODAL_STEPPER_BID: {
    MC: 'b_waimai_c_overseas_eag2ivu5_mc'
  },

  MULTI_SAME_SPU_LANDSCAPE_VIEW_BID: {
    MC: 'b_sailor_c_0k5s2xep_mc',
    MV: 'b_sailor_c_0k5s2xep_mv'
  }
};

let userGetMode = UserGetMode.delivery;

export function setTrackUserGetMode(inputUserGetMode) {
  userGetMode = inputUserGetMode;
}
export function getTrackUserGetMode() {
  return userGetMode;
}

export default class TrackUtils {
  static getMultiSkuModalLab = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number) => {
    const lab = {
      componentInfo: multiSkuModel?.componentInfo || {},
      customer_type: canUserCoupon || 0,
      gd_page_id: multiSkuModel?.gdPageId || '-999',
      gd_activity_id: multiSkuModel?.activity_id || '-999',
      resource_id: multiSkuModel?.resource_id || '-999',
      sku_index: multiSkuModel?.index || 0,
      sku_number: curGoodDetail?.skuList?.length || 0,
      shop_id: shopId,
      spu_id: curGoodDetail?.spuId,
      source_page: source
    };
    return lab;
  }

  //machpro弹窗类型多规格页面曝光埋点
  static multiSkuModalPageMV = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number) => {
    const cid = CID.multi_sku_modal;
    const bid = BID.NORMAL_MULTI_SKU_MODAL_BID.MV;
    const lab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    Statistics.view(cid, bid, lab);
  }

  static multiSkuModalEnterShopMV = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number, originalPrice: string, discountPrice: string) => {
    const cid = CID.multi_sku_modal;
    const bid = BID.NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID.MV;
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const lab = {
      original_price: originalPrice || '0',
      sale_price: discountPrice || '0',
      ...normalLab
    };
    Statistics.view(cid, bid, lab);
  }

  static multiSkuModalEnterShopMC = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, canUserCoupon: number | undefined, source: number, originalPrice: string, discountPrice: string) => {
    const cid = CID.multi_sku_modal;
    const bid = BID.NORMAL_MULTI_SKU_MODAL_ENTER_SHOP_BID.MC;
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const lab = {
      original_price: originalPrice || '0',
      sale_price: discountPrice || '0',
      ...normalLab
    };
    Statistics.click(cid, bid, lab);
  }

  static multiSkuModalCheckoutMC = (multiSkuModel: MultiSkuModel, curGoodDetail: GoodDetailData, shopId: string, selectedSkuId: number, canUserCoupon: number | undefined, source: number, originalPrice: string, discountPrice: string) => {
    const cid = CID.multi_sku_modal;
    const bid = BID.NORMAL_MULTI_SKU_MODAL_CHECKOUT_BID.MC;
    const normalLab = TrackUtils.getMultiSkuModalLab(multiSkuModel, curGoodDetail, shopId, canUserCoupon, source);
    const lab = {
      original_price: originalPrice || '0',
      sale_price: discountPrice || '0',
      sku_id: selectedSkuId || 0,
      ...normalLab
    };
    Statistics.click(cid, bid, lab);
  }

  // 多规格页面曝光埋点
  static multiSkuPageMV = (fixedPrice: boolean, shopId: string, curGoodDetail: GoodDetailData, selectedSku: GoodDetailSkuList, moduleSource?: string) => {
    const cid = fixedPrice ? CID.fixed_price : CID.shop;
    const bid = fixedPrice ? BID.FIXED_PRICE_POI_CHOOSE_SPEC.MV : BID.POI_CHOOSE_SPEC_VIEW_BID.MV;
    const user_get_mode = getTrackUserGetMode();
    // 是否为自动打开多规格浮层moduleSource
    const lab = {
      picture_url: curGoodDetail.pictures,
      shop_id: shopId,
      spu_description: curGoodDetail.description,
      spu_id: curGoodDetail.spuId,
      sku_id: selectedSku?.skuId,
      source_page: fixedPrice ? 1 : 0,
      user_get_mode,
      /** module_source: 1 金刚落地页下挂菜卡片跳转(金刚落地页细分场景） */
      module_source: moduleSource || Constant.STATISTICS_NON_VALUE,
    };
    Statistics.view(cid, bid, lab);
  }

  static variationMV = (fixedPrice: boolean, logData: string | undefined, spuCalorie: string | undefined) => {
    const cid = fixedPrice ? CID.fixed_price : CID.shop;
    const bid = fixedPrice ? BID.FIXED_PRICE_MULT_SKU_VARIATION.MV : BID.MULT_SKU_VARIATION.MV;
    const logDataForLx = logData ? JSON.parse(logData) : {};
    const spuCalorieForLx = { spu_calorie: spuCalorie || '' };
    const lab = { ...logDataForLx, ...spuCalorieForLx };
    const user_get_mode = getTrackUserGetMode();

    Statistics.view(cid, bid, { ...lab, user_get_mode });
  }

  // 规格浮层-分享点击
  static shareBtnMC = (lab: any) => {
    const fixedPrice = lab.source_page === 1;
    const cid = fixedPrice ? CID.fixed_price : CID.shop;
    const bid = fixedPrice ? BID.FIXED_PRICEMULT_SKU_SHARE_BTN.MC : BID.MULT_SKU_SHARE_BTN.MC;
    Statistics.click(cid, bid, lab);
  }

  // 规格浮层-加入购物车
  static addShopcartMC = (key: string, fixedPrice: boolean, totalPrice: TotalPrice, shop_id: string, sku: SelectedSkuList, count: number, curGoodDetail: GoodDetailData) => {
    const newGroupSkuList: string[] = [];
    if (sku.groupList && sku.groupList.length > 0) {
      sku.groupList.forEach((groupList) => {
        if (groupList.groupSkuList) {
          groupList.groupSkuList.forEach((groupSkuListItem) => {
            if (groupSkuListItem.count > 0) {
              newGroupSkuList.push(`${groupSkuListItem.groupSkuId},${groupSkuListItem.count}`);
            }
          });
        }
      });
    }

    const spu_specifications = newGroupSkuList.join(';');
    const bid = fixedPrice ? BID.FIXED_PRICE_MULT_SKU_ADD_TO_SHOPCART_BTN.MC : BID.MULT_SKU_ADD_TO_SHOPCART_BTN.MC;
    const cid: string = fixedPrice ? CID.fixed_price : CID.shop;
    const user_get_mode = getTrackUserGetMode();

    const skuLab = {
      discount_information: sku.extraInfo?.logData ? (JSON.parse(sku.extraInfo.logData)?.discount_information) : '',
      discount_amount: ((totalPrice.originPrice.amount - totalPrice.discountPrice?.amount) / 100).toFixed(2),
      bid,
      original_price: totalPrice.originPrice,
      sale_price: totalPrice.discountPrice,
      shop_id,
      sku_id: sku.skuId,
      sku_number: count,
      spu_id: curGoodDetail?.spuId,
      currency_type: totalPrice.currency,
      discount_price: totalPrice?.discountPrice || '',
      activity_type: sku?.activityInfoList?.[0].activityType || 0,
      spu_specifications,
      user_get_mode,
    };
    const tagLab = {
      [cid]: {
        ...skuLab,
        bid,
      },
    };
    Statistics.setTag && Statistics.setTag(key, tagLab);
    Statistics.click(cid, bid, skuLab);
  }

  //规格页面数量埋点
  static countMC = (count: number, lab: any, button_name: number) => {
    const user_get_mode = getTrackUserGetMode();
    const countLab = {
      ...lab,
      sku_number: count,
      button_name,
      user_get_mode,
    };
    Statistics.click(CID.shop, BID.MULT_SKU_CHANGE_COUNT.MC, countLab);
  }

  //查看更多点击
  static viewMoreMC = (fixedPrice: boolean, spu_id: number, shop_id: string, group_name: string) => {
    const cid: string = fixedPrice ? CID.fixed_price : CID.shop;
    const bid: string = fixedPrice ? BID.FIXED_PRICE_MULT_SKU_SHOW_MORE_BTN.MC : BID.MULT_SKU_SHOW_MORE_BTN.MC;
    const user_get_mode = getTrackUserGetMode();

    const lab = {
      shop_id,
      spu_id,
      group_name,
      user_get_mode,
    };
    Statistics.click(cid, bid, lab);
  }

  // 备注曝光
  static remarkMV = (fixedPrice: boolean, shop_id: string, spu_id: number) => {
    const cid = fixedPrice ? CID.fixed_price : CID.shop;
    const bid = fixedPrice ? BID.FIXED_PRICE_MULT_SKU_REMARK.MV : BID.MULT_SKU_REMARK.MV;
    const user_get_mode = getTrackUserGetMode();
    Statistics.view(cid, bid, {
      shop_id,
      spu_id,
      user_get_mode,
    });
  }

  // 备注点击
  static remarkMC = (fixedPrice: boolean, shop_id: string, spu_id: number) => {
    const cid = fixedPrice ? CID.fixed_price : CID.shop;
    const bid = fixedPrice ? BID.FIXED_PRICE_MULT_SKU_REMARK.MC : BID.MULT_SKU_REMARK.MC;
    const user_get_mode = getTrackUserGetMode();
    Statistics.click(cid, bid, {
      shop_id,
      spu_id,
      user_get_mode,
    });
  }

  //规格模块曝光
  static attrGroupMV = (fixedPrice: boolean, shop_id: string, spu_id: number, spu_specifications_number: number, group_name: string, rule_tag: string, discount_price: string, activity_type: number) => {
    const cid = fixedPrice ? CID.fixed_price : CID.shop;
    const bid = fixedPrice ? BID.FIXED_PRICE_MULT_SKU_SKULIST.MV : BID.MULT_SKU_SKULIST.MV;
    const user_get_mode = getTrackUserGetMode();

    const lab = {
      shop_id,
      spu_id,
      spu_specifications_number,
      group_name,
      rule_tag,
      discount_price,
      activity_type,
      user_get_mode
    };
    Statistics.view(cid, bid, lab);
  }

  // 919活动多规格弹窗MV
  static nineOneNineMultiSkuPageMV = (shop_id: number, user_status: number, shop_brand_id: number) => {
    const cid = CID.nine_one_nine;
    const bid = BID.NINE_ONE_NINE_MULT_SKU_BID.MV;
    const lab = {
      shop_id,
      user_status,
      shop_brand_id,
    };
    Statistics.view(cid, bid, lab);
  }

  static gaodaMarketingFloatingLayerMV(lab = {}, parameterCid?: string) {
    const cid = parameterCid || CID.nine_one_nine;
    const bid = BID.MARKETFLOADINGLAYER_BID.MV;
    Statistics.view(cid, bid, lab);
  }

  static gaodaMarketingFloatingLayerMC(lab = {}, parameterCid?: string) {
    const cid = parameterCid || CID.nine_one_nine;
    const bid = BID.MARKETFLOADINGLAYER_BID.MC;
    Statistics.click(cid, bid, lab);
  }

  static gaodaMarketingPopUPMV(lab = {}, parameterCid?: string) {
    const cid = parameterCid || CID.nine_one_nine;
    const bid = BID.MARKETFLOADINGLAYER_POPUP_VIEW_BID.MV;
    Statistics.view(cid, bid, lab);
  }

  static gaodaMarketingPopUPMC(lab = {}, parameterCid?: string) {
    const cid = parameterCid || CID.nine_one_nine;
    const bid = BID.MARKETFLOADINGLAYER_POPUP_VIEW_BID.MC;
    Statistics.click(cid, bid, lab);
  }

  // 919活动弹窗MV
  static nineOneNineMultiSkuPopupViewMV = (shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const cid = CID.nine_one_nine;
    const bid = BID.NINE_ONE_NINE_POPUP_VIEW_BID.MV;
    const lab = {
      shop_id,
      user_status,
      shop_brand_id,
      remind_reason,
    };
    Statistics.view(cid, bid, lab);
  }

  // 919活动弹窗按钮MC
  static nineOneNineMultiSkuPopupViewMC = (button_name: string, shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const cid = CID.nine_one_nine;
    const bid = BID.NINE_ONE_NINE_POPUP_VIEW_BID.MC;
    const lab = {
      button_name,
      shop_id,
      user_status,
      shop_brand_id,
      remind_reason,
    };
    Statistics.click(cid, bid, lab);
  }

  // 919活动落地页-规格浮层-加购
  static nineOneNineAddShopcartMC = (sku_id: number, user_status: number, shop_brand_id: number) => {
    const cid = CID.nine_one_nine;
    const bid = BID.NINE_ONE_NINE_MULT_SKU_ADD_TO_SHOPCART_BTN.MC;
    const lab = {
      sku_id,
      user_status,
      shop_brand_id,
    };
    Statistics.click(cid, bid, lab);
  }

  // 店铺休息弹窗Mv
  static previewCommonDialogMV = (source: number, shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const fixedPrice = source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE;
    const cid = fixedPrice ? CID.fixed_price : CID.nine_one_nine;
    const bid = fixedPrice ? BID.FIXED_PRICE_COMMON_DIALOG_BID.MV : BID.PREVIEW_COMMON_DIALOG_BID.MV;
    const lab = {
      shop_id,
      remind_reason,
    };
    if (!fixedPrice) {
      Object.assign(lab, { user_status, shop_brand_id });
    }
    Statistics.view(cid, bid, lab);
  }

  // 商品已下架、删除mv
  static previewCommonDialogMC = (source: number, shop_id: number, user_status: number, shop_brand_id: number, remind_reason: number) => {
    const fixedPrice = source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE;
    const cid = fixedPrice ? CID.fixed_price : CID.nine_one_nine;
    const bid = fixedPrice ? BID.FIXED_PRICE_COMMON_DIALOG_BID.MC : BID.PREVIEW_COMMON_DIALOG_BID.MC;
    const lab = {
      shop_id,
      remind_reason,
    };
    if (!fixedPrice) {
      Object.assign(lab, { user_status, shop_brand_id });
    }
    Statistics.click(cid, bid, lab);
  }

  static stepperMC = (lab) => {
    const cid = CID.shop;
    const bid = BID.NORMAL_MULTI_SKU_MODAL_STEPPER_BID.MC;
    const user_get_mode = getTrackUserGetMode();

    Statistics.click(cid, bid, { ...lab, user_get_mode });
  }

  static multiSameSpuChangeClickMC = (isFixedcePrice, lab) => {
    const cid = isFixedcePrice ? CID.fixed_price : CID.shop;
    const bid = BID.MULTI_SAME_SPU_LANDSCAPE_VIEW_BID.MC;
    Statistics.click(cid, bid, lab);
  }

  static multiSameSpuChangeMV = (isFixedcePrice, lab) => {
    const cid = isFixedcePrice ? CID.fixed_price : CID.shop;
    const bid = BID.MULTI_SAME_SPU_LANDSCAPE_VIEW_BID.MV;
    Statistics.view(cid, bid, lab);
  }

  // 一口价-规格浮层-门店入口-MC
  static fixedPriceShopEntryMC = (shop_id: number) => {
    const cid = CID.fixed_price;
    const bid = BID.FIXED_PRICE_SHOP_ENTRY.MC;
    Statistics.click(cid, bid, { shop_id });
  }
  // 一口价-规格浮层-门店入口-MV
  static fixedPriceShopEntryMV = (shop_id: number) => {
    const cid = CID.fixed_price;
    const bid = BID.FIXED_PRICE_SHOP_ENTRY.MV;
    Statistics.view(cid, bid, { shop_id });
  }
}
